window.addEventListener('DOMContentLoaded', () => {
  // wrapper
  sizingGuideWrapper()

  function sizingGuideWrapper () {
    // -------- Not used currently ------

    // let selectors = {
    //     sizeSelector: '[data-size-selector]',
    //     sizeOption: '[data-size-option]',
    //     sizeLabels: '[data-size-label]',
    //     sizeResult: '[data-size-result]',
    //     sizeResultTop: '[data-size-result-top]',
    //     sizeResultBottom: '[data-size-result-bottom]',
    //     sizeTab: '[data-size-tab]'
    // };

    const sizes = {
      triangl: ['XXS', 'XS', 'S', 'M', 'L', 'XL'],
      regions: {
        US: ['0', '2', '4', '6', '8', '10'],
        EU: ['32', '34', '36', '38', '40', '42'],
        IT: ['36', '38', '40', '42', '44', '46'],
        FR: ['32', '34', '36', '38', '40', '42'],
        UK: ['4', '6', '8', '10', '12', '14'],
        AUS: ['4', '6', '8', '10', '12', '14']
      },
      tops: [
        ['76-79', '67-70'],
        ['80-83', '71-74'],
        ['84-87', '75-78'],
        ['88-91', '79-82'],
        ['92-95', '83-86'],
        ['96-99', '87-90'],
      ],
      bottoms: [
        ['59-62', '85-88', '75-78'],
        ['63-66', '89-92', '79-82'],
        ['67-70', '93-96', '83-86'],
        ['71-74', '97-100', '87-90'],
        ['75-78', '101-104', '91-94'],
        ['79-82', '105-108', '95-98'],
      ],
    }

    // ---------------- Tops and Bottoms Size Guide -----------------
    topsAndBottomsGuide()

    function topsAndBottomsGuide () {
      // Type Trigger selection effect on icons
      document.addEventListener('click', (selectionClick) => {
        const sizingTypeOption = document.getElementsByClassName('sizing-type-option')

        for (let k = 0; k < sizingTypeOption.length; k++) {
          const availableTypesAttr = sizingTypeOption[k].getAttribute('sizing-type-current-selection')

          if (selectionClick.target.hasAttribute('sizing-type-current-selection') || selectionClick.target.parentNode.parentNode.hasAttribute('sizing-type-current-selection')) {
            if ((selectionClick.target.getAttribute('sizing-type-current-selection') === availableTypesAttr) || (selectionClick.target.parentNode.parentNode.getAttribute(availableTypesAttr === 'sizing-type-current-selection'))) {
              sizingTypeOption[k].classList.add('checked')
              sizingTypeOption[k].parentNode.classList.add('checked')
            } else {
              sizingTypeOption[k].classList.remove('checked')
              sizingTypeOption[k].parentNode.classList.remove('checked')
            }
          }
        }
      })

      // ------ Tops - Bottoms label trigger
      document.addEventListener('click', (eventClicked) => {
        const sizingGuideData = document.getElementsByClassName('sizing-guide__data')

        if (eventClicked.target.getAttribute('data-style-option') === 'tops' || eventClicked.target.parentNode.parentNode.getAttribute('data-style-option') === 'tops') {
          for (let i = 0; i < sizingGuideData.length; i++) {
            if (sizingGuideData[i].hasAttribute('data-size-result-top')) {
              sizingGuideData[i].classList.remove('hide')
            }
            if (sizingGuideData[i].hasAttribute('data-size-result-bottom')) {
              sizingGuideData[i].classList.add('hide');
            }
          }
        }

        if (eventClicked.target.getAttribute('data-style-option') === 'bottoms' || eventClicked.target.parentNode.parentNode.getAttribute('data-style-option') === 'bottoms') {
          for (let i = 0; i < sizingGuideData.length; i++) {
            if (sizingGuideData[i].hasAttribute('data-size-result-top')) {
              sizingGuideData[i].classList.add('hide')
            }
            if (sizingGuideData[i].hasAttribute('data-size-result-bottom')) {
              sizingGuideData[i].classList.remove('hide')
            }
          }
        }
      })
      // ----- Tops - Bottoms selection END

      // ----- Region selection
      const divSizingRegionSelectors = document.getElementsByClassName('options-selector__label-region-option')
      const divSizeInputs = document.getElementsByClassName('options-selector__label-size-numbers')

      for (let i = 0; i < divSizingRegionSelectors.length; i++) {
        divSizingRegionSelectors[i].addEventListener('click', () => {
          if (divSizingRegionSelectors[i].innerText === 'US') {
            for (let k = 0; k < sizes.regions.US.length; k++) {
              divSizeInputs[k].innerHTML = sizes.regions.US[k]
            }
          }
          if (divSizingRegionSelectors[i].innerText === 'EU') {
            for (let k = 0; k < sizes.regions.EU.length; k++) {
              divSizeInputs[k].innerHTML = sizes.regions.EU[k]
            }
          }
          if (divSizingRegionSelectors[i].innerText === 'IT') {
            for (let k = 0; k < sizes.regions.IT.length; k++) {
              divSizeInputs[k].innerHTML = sizes.regions.IT[k]
            }
          }
          if (divSizingRegionSelectors[i].innerText === 'FR') {
            for (let k = 0; k < sizes.regions.FR.length; k++) {
              divSizeInputs[k].innerHTML = sizes.regions.FR[k]
            }
          }
          if (divSizingRegionSelectors[i].innerText === 'UK') {
            for (let k = 0; k < sizes.regions.UK.length; k++) {
              divSizeInputs[k].innerHTML = sizes.regions.UK[k]
            }
          }
          if (divSizingRegionSelectors[i].innerText === 'AUS') {
            for (let k = 0; k < sizes.regions.AUS.length; k++) {
              divSizeInputs[k].innerHTML = sizes.regions.AUS[k]
            }
          }
        })
      }
      // ----- Region selection END

      // ----- Sizes Selection
      document.addEventListener('click', (sizeClick) => {
        const sizingLabelTriangl = document.getElementsByClassName('sizing-label-triangl')

        for (let loopLabels = 0; loopLabels < sizingLabelTriangl.length; loopLabels++) {
          if (sizeClick.target.getAttribute('for') === 'sizing-size-0') {
            sizingLabelTriangl[loopLabels].classList.add('hide')

            if (sizingLabelTriangl[loopLabels].getAttribute('data-size-result') === 'XXS') {
              sizingLabelTriangl[loopLabels].classList.remove('hide')
            }
          }
          if (sizeClick.target.getAttribute('for') === 'sizing-size-1') {
            sizingLabelTriangl[loopLabels].classList.add('hide')

            if (sizingLabelTriangl[loopLabels].getAttribute('data-size-result') === 'XS') {
              sizingLabelTriangl[loopLabels].classList.remove('hide')
            }
          }
          if (sizeClick.target.getAttribute('for') === 'sizing-size-2') {
            sizingLabelTriangl[loopLabels].classList.add('hide')

            if (sizingLabelTriangl[loopLabels].getAttribute('data-size-result') === 'S') {
              sizingLabelTriangl[loopLabels].classList.remove('hide')
            }
          }
          if (sizeClick.target.getAttribute('for') === 'sizing-size-3') {
            sizingLabelTriangl[loopLabels].classList.add('hide')

            if (sizingLabelTriangl[loopLabels].getAttribute('data-size-result') === 'M') {
              sizingLabelTriangl[loopLabels].classList.remove('hide')
            }
          }
          if (sizeClick.target.getAttribute('for') === 'sizing-size-4') {
            sizingLabelTriangl[loopLabels].classList.add('hide')

            if (sizingLabelTriangl[loopLabels].getAttribute('data-size-result') === 'L') {
              sizingLabelTriangl[loopLabels].classList.remove('hide')
            }
          }
          if (sizeClick.target.getAttribute('for') === 'sizing-size-5') {
            sizingLabelTriangl[loopLabels].classList.add('hide')

            if (sizingLabelTriangl[loopLabels].getAttribute('data-size-result') === 'XL') {
              sizingLabelTriangl[loopLabels].classList.remove('hide')
            }
          }
        }
      })
    }
    // ---------------- Tops and Bottoms Size Guide END-----------------

    // ---------------- Navigation Help button
    const navButtons = document.querySelectorAll('[href="#live-chat"]')

    navButtons.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        const sizeGuideDrawer = document.querySelector('#sizingGuideModal')
        if (sizeGuideDrawer) { sizeGuideDrawer.style.zIndex = 100 }
        const quickAddModal = document.querySelector('quick-add-modal')
        if (quickAddModal) { quickAddModal.style.zIndex = 99 }
        const chatWidget = document.querySelector('.chat-widget')
        if (!chatWidget.classList.contains('chat-widget--close')) { chatWidget.click() }
      })
    })

    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('minimize-button') || e.target.classList.contains('chat-button')) {
        const webchat = document.querySelector('.widget-container.normal')
        const chatbutton = document.querySelector('.chat-button')

        webchat.classList.toggle('visible')
        chatbutton.classList.toggle('visible')
      }
    })
  }
  // wrapper END
})
